import type { DeepPartial, MinimalTheme } from '@ovasabi/ui-minimal'
import { appTheme } from './theme'
import { EDITION_PROFILE, type Edition } from '../lib/edition'

/**
 * Per-edition theme override = the base Chow `appTheme` (typography, surfaces)
 * restained with the edition's accent. Passed to `MinimalThemeProvider`, which
 * merges it onto the ui-minimal base — so every primitive's `brand` token (and
 * the exported CSS variables) switch to the active product at runtime.
 */
export const editionThemeOverride = (edition: Edition): DeepPartial<MinimalTheme> => {
  const { brand, brandSoft } = EDITION_PROFILE[edition].accent
  return {
    ...appTheme,
    name: `chow-${edition}`,
    color: {
      ...(appTheme.color ?? {}),
      brand,
      brandSoft,
      borderFocus: brand,
    },
  }
}
